class Network {
    _request = (url, params, timeout = 15000) => {
        const controller = new AbortController();
        const signal = controller.signal;

        let timeoutAction = null;
        let timerPromise = new Promise((resolve, reject) => {
            timeoutAction = () => {
                reject('TimeOut!!!');
                controller.abort();
            }
        });
        setTimeout(() => {
            timeoutAction();
        }, timeout);

        let requestPromise = new Promise(async (resolve, reject) => {
            params.signal = signal;
            return fetch(url, params)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        reject('network error');
                    }
                })
                .then(resData => {
                    resolve(resData);
                })
                .catch(error => {
                    reject('network error');
                });
        });

        return Promise.race([requestPromise, timerPromise]);
    }

    get = (url, params = null) => {
        const headers = {
            "Content-Type": "application/json"
        };
        const config = {
            method: 'get',
            headers: headers
        };
        let getURL = url;
        if (params) {
            const queryStr = this._objectToQueryString(params);
            getURL = `${url}?${queryStr}`
        }
        console.log(`Network GET url: ${getURL}`);
        return new Promise((resolve, reject) => {
            this._request(getURL, config)
                .then(response => {
                    console.log('Network GET res: ', JSON.stringify(response))
                    if (response.code == 200) {
                        resolve(response.data);
                    } else {
                        reject(response)
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    _objectToQueryString = (obj) => {
        return Object.keys(obj).map(key => {
            return ''.concat(encodeURIComponent(key), '=').concat(encodeURIComponent(obj[key]));
        }).join('&');
    }
}
export default new Network()